"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScheduleByMapper = void 0;
const getScheduleByMapper = (valueMapper, value) => {
    const mapper = Object.keys(valueMapper).reduce((acc, key, index) => {
        acc[index] = key;
        return acc;
    }, {});
    return value === null || value === void 0 ? void 0 : value.reduce((acc, cur, index) => {
        if (cur) {
            acc.push(mapper[index]);
        }
        return acc;
    }, []);
};
exports.getScheduleByMapper = getScheduleByMapper;
//# sourceMappingURL=getScheduleByMapper.js.map